var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import { forwardRef } from 'react';
import * as styles from './baseButton.linaria';
/**
 * This button is used as the 'base' for the other buttons we are building in the component library.
 */
export const BaseButton = forwardRef((_a, ref) => {
    var { children, className, onClick, ariaLabel, type } = _a, rest = __rest(_a, ["children", "className", "onClick", "ariaLabel", "type"]);
    return (<button {...rest} ref={ref} type={
        // eslint-disable-next-line react/button-has-type
        type} onClick={onClick} className={classNames(styles.baseButton, className)} aria-label={ariaLabel}>
      {children}
    </button>);
});
BaseButton.defaultProps = {
    className: null,
    onClick: null,
    ariaLabel: null,
    type: 'button',
};
export default BaseButton;
